import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

function applyLandscapeAnimation(triggerInfo) {
    
    let landscapeAnimationTrigger = ScrollTrigger.create({
        trigger: triggerInfo.trigger,
        endTrigger: triggerInfo.endTrigger,
        start: triggerInfo.start,
        end: triggerInfo.end,
        scrub: true,
        animation: gsap.fromTo(".planet-landscape-container", {y: 0},{y: triggerInfo.y})
    })
    return landscapeAnimationTrigger
}

export default applyLandscapeAnimation